<template>
  <div>
    <nav class="hidden md:block secondary-nav">
      <ul>
        <li :class="{ active: statusIs('published') }">
          <a
            :href="$urlGenerator.active('communications/')"
            v-text="'Latest'"
          />
        </li>
        <li
          v-can="'view-draft-comms'"
          :class="{ active: statusIs('draft') }"
        >
          <a
            :href="$urlGenerator.active('communications/drafts')"
            v-text="'Drafts'"
          />
        </li>
        <li
          v-can="'view-scheduled-comms'"
          :class="{ active: statusIs('scheduled') }"
        >
          <a
            :href="$urlGenerator.active('communications/scheduled')"
            v-text="'Scheduled'"
          />
        </li>
        <li
          v-can="'view-archived-comms'"
          :class="{ active: statusIs('archived') }"
        >
          <a
            :href="$urlGenerator.active('communications/archived')"
            v-text="'Archived'"
          />
        </li>
      </ul>
    </nav>
  </div>
</template>

<script type="text/babel">

export default {
  name: 'CommunicationPageTabs',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  methods: {
    statusIs(status) {
      return this.status === status
    },

    mobileNavigation(e){
      window.location = e.target.value
    },
  },
}
</script>
